<template>
  <a-row class="fulfillment">
    <div class="position-absolute mt-2 pbz-font body-md-bold">
      {{ $t('sideBar.do') }}
    </div>
    <a-col :span="24" class="d-flex justify-content-center align-items-center">
      <div class="search-box mx-2">
        <SearchIcon class="i" style="color: #999999" />
        <input
          v-model="querySearch"
          class="field"
          type="text"
          :placeholder="`${$t('fulfillment.search')} No Order / SKU`"
          @input="handleSearch"
        />
      </div>

      <div class="mx-2 filter-box" @click="handleFilter()">
        <div>
          <FilterIcon style="color: #999999" />
        </div>
        <div class="caption">
          {{ $t('utils.filter') }}
        </div>
      </div>
      <a-button
        type="primary"
        size="large"
        class="mr-2"
        @click.prevent="handleShowModalExportData(true)"
      >
        {{ $t('warehouse.export_data') }}
      </a-button>
      <a-dropdown v-if="!typeActiveBulkActions" :trigger="['click']" arrow>
        <a-button type="secondary" size="large" :disabled="loadingList" :loading="loadingList">
          <a-icon v-if="!loadingList" type="bars" />
          {{ $t('utils.bulk_actions') }}
        </a-button>
        <template #overlay>
          <a-menu>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'created,confirmed'" key="1">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['CREATED', 'CONFIRMED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_accepted') }}</a>
            </a-menu-item>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'accepted'" key="1">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['ACCEPTED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_picking') }}</a>
            </a-menu-item>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'pick_confirmed'" key="2">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['PICK_CONFIRMED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_packing') }}</a>
            </a-menu-item>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'packing_completed'" key="3">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['PACKING_COMPLETED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_good_issued') }}</a>
            </a-menu-item>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'good_issued'" key="4">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['GOOD_ISSUED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_shipped') }}</a>
            </a-menu-item>
            <a-menu-item v-if="!$route.query.delivery_order_states || $route.query.delivery_order_states === 'shipped'" key="5">
              <a @click="typeActiveBulkActions = 'bulk-process'; bulkState = ['SHIPPED']"><a-icon type="reconciliation" class="mr-2" />{{ $t('fulfillment.bulk_delivered') }}</a>
            </a-menu-item>

            <a-menu-item key="8">
              <a @click="typeActiveBulkActions = 'print-picking-list'"><a-icon type="printer" class="mr-2" />{{ $t('fulfillment.print_picking_list') }}</a>
            </a-menu-item>
            <a-menu-item key="9">
              <a @click="typeActiveBulkActions = 'print-shipping-label'"><a-icon type="printer" class="mr-2" />{{ $t('fulfillment.print_shipping_label') }}</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <a-modal :visible="filter" :closable="false" :footer="null">
        <FilterList
          :reset="resetFilter"
          :clear="clear"
          :warehouse-list="warehouse_list"
          :service-list="service_list"
          @setLoading="setLoading"
          @visible="cancelModal($event)"
          @setWarehouseId="setWarehouseId($event)"
        />
      </a-modal>
    </a-col>

    <a-col
      v-if="getFilterParam"
      :span="24"
      class="categories d-flex justify-content-start align-items-start text-left"
      style="flex-wrap: wrap"
    >
      <div
        v-for="item in activeFilter"
        :key="item"
        class="list active pbz-font overline-medium"
        style="cursor: text"
      >
        {{ item }}
      </div>
      <a-button
        class="cancel-button pbz-font button-sm-medium"
        style="width: auto; height: auto; border: none"
        @click="resetFilter"
      >
        {{ $t('utils.clearFilter') }}
      </a-button>
    </a-col>

    <a-col
      :span="24"
      class="categories d-flex justify-content-start align-items-start text-left"
      style="flex-wrap: wrap"
    >
      <div
        v-for="(item, index) in categorie_state"
        :key="index"
        class="list"
        :class="activeCategories === item.value && 'active'"
        @click.prevent="changeCategorieState(item.value)"
      >
        {{ item.title }}
        <a-icon v-if="loadingTotal" type="loading" style="color: red" />
        <template v-if="!loadingTotal">
          ({{ total[item?.value?.split(',')?.[0]] || 0 }})
        </template>
      </div>
      <div
        class="list"
        :class="activeCategories === 'trouble' && 'active'"
        @click.prevent="changeCategorieState('trouble')"
      >
        {{ $t('fulfillment.check_do_data') }}
      </div>
    </a-col>

    

    <a-col v-if="fulfillment.length" :span="24" style="padding: 10px 20px">
      <a-row>
        <a-col
          :span="12"
          class="d-flex justify-content-start align-items-center"
        >
          <div>
            <a-checkbox
              v-if="
                !isMasterFulfillment &&
                  ![
                    'all',
                    'good_issued',
                    'canceled',
                    'cancel_requested',
                  ].includes(activeCategories)
              "
              :indeterminate="indeterminate_checked"
              :checked="all_item_checked"
              class="pbz-font body-md-bold"
              style="color: #999999"
              @change="checkboxSelectAllFulfillment"
            >
              {{ $t('fulfillment.all') }}
            </a-checkbox>
          </div>

          <div
            v-if="show_button_bulk && !isMasterFulfillment"
            style="cursor: pointer"
            class="d-flex mx-3"
          >
            <div class="mr-2">
              <img
                src="https://cdn-2.powerbiz.asia/saas/Icons__2_.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1642492365818"
              />
            </div>
            <div
              class="ml-2 pbz-font body-md-bold"
              style="color: #0559cb"
              @click.prevent="handleButtonAcceptBulkOrder"
            >
              {{ captionBulkyUpdate }}
            </div>
          </div>
        </a-col>
      </a-row>

      <a-modal
        :visible="showModalNotifToSetFilter"
        :footer="null"
        @cancel="() => (showModalNotifToSetFilter = false)"
      >
        <ContentModalNotifToSetFilter
          @clickSetFilter="
            () => ((filter = true), (showModalNotifToSetFilter = false))
          "
          @clickCancelModal="() => (showModalNotifToSetFilter = false)"
        />
      </a-modal>
    </a-col>

    <a-col v-if="typeActiveBulkActions" class="pb-3 h-100" span="24">
      <div class="d-flex justify-content-start align-items-center" style="gap: 10px;">
        <a-alert :message="$t('fulfillment.select_order_to_be', { action: bulkDescription.message })" type="info" show-icon style="flex: auto;" />
        <a-button type="primary" size="large" :disabled="!fulfillment_ids.length" @click="handleBulkActions">
          <a-icon :type="bulkDescription.icon" class="mr-1" />{{ bulkDescription.title }}
        </a-button>
        <a-button type="secondary" size="large" @click="onCancelBulkActions">
          <a-icon type="close" class="mr-1" />{{ $t('fulfillment.cancel_bulk_actions') }}
        </a-button>
      </div>
    </a-col>

    <a-col
      class="table-responsive pb-2"
      :style="{ maxHeight: screenHeight }"
    >
      <div
        class="container-fluid border rounded py-2 mx-0"
        :style="{ minWidth: listWidth + 'px', position: 'sticky', top: 0, background: 'white', zIndex: 2 }"
      >
        <div class="row flex-nowrap row-calc">
          <div v-if="typeActiveBulkActions" class="px-1 text-truncate w-8" style="padding-left: 8px !important;">
            <a-tooltip>
              <template v-if="getFulfillmentLengthEligibleBulkActions === 0" #title>
                {{ $t('fulfillment.bulk_actions_no_eligible') }}
              </template>
              <a-checkbox
                :checked="isCheckedAllBulkActions"
                :indeterminate="isIntermediateBulkActions"
                :disabled="getFulfillmentLengthEligibleBulkActions === 0"
                @change="onCheckAllBulkActions($event)"
              />
            </a-tooltip>
          </div>
          <div
            v-for="tr in [
              'created_date',
              'order_date',
              'order_id',
              'shipping_id',
              'business',
              'store',
              'warehouse',
              'totalItem',
              'priority_level',
              'sla',
              'booking_status',
            ]"
            :key="tr"
            :class="[
              'col',
              'text-truncate',
              tr === 'checkbox' ? 'w-8' : '',
            ]"
            :style="tr === 'totalItem' ? 'max-width: 10% !important; flex-basis: 10% !important;': ''"
          >
            <span>{{
              $t('fulfillment.' + tr)
            }}</span>
          </div>
          <div class="col px-1 align-items-center" style="max-width: 21% !important; flex-basis: 21% !important;">
            {{ $t('fulfillment.status') }}
          </div>
          <div class="" style="width: 60px !important; position: sticky; right: 0; background: white;" />
        </div>
      </div>

      <LoadingListTable v-if="loadingList" class="my-2" />
      <template v-else>
        <ErrorInfo v-if="errorRows" :error-type="errorRows" />
        <template v-else>
          <template v-if="fulfillment.length">
            <FufillmentList
              v-for="(item, index) in fulfillment"
              :key="index"
              :item="item"
              :item-num="index"
              :position="position"
              :item-checked="getItemChecked(item.order_id)"
              :active-categories="activeCategories"
              :permission="permission"
              :width="listWidth"
              :warehouse-list="warehouse_list"
              :type-active-bulk-actions="typeActiveBulkActions"
              :bulk-order-state="bulkOrderState"
              :service-list="service_list"
              class="mt-2"
              @handleItemChecked="handleItemChecked"
              @handleItemSubmitted="handleItemSubmitted"
              @onCheckBulkActions="onCheckBulkActions"
              @setOrderIdToUpdated="setOrderIdToUpdated"
              @setModalInformationProcessingState="setModalInformationProcessingState"
              @setHaveActionButton="setHaveActionButton"
              @setShowModalPrintLabel="setShowModalPrintLabel"
              @onClickAccepted="onClickAccepted"
              @onClickRevision="onClickRevision"
              @onClickCancelOrder="onClickCancelOrder"
              @onClickUpdatePackage="onClickUpdatePackage"
            />
          </template>
          <EmptyInfo
            v-if="!fulfillment.length && isFetch"
            class="py-5"
            :title="$t('order.empty_title')"
            :description="$t('order.empty_msg')"
          />
        </template>
      </template>
    </a-col>

    <a-col
      v-if="fulfillment.length"
      :span="24"
      style="margin-top: 24px"
      class="d-flex justify-content-end"
    >
      <a-pagination
        :current="page"
        :page-size="limit"
        :page-size-options="sizeOptions"
        :total="total_row"
        :show-total="
          (total, range) =>
            $t('utils.pagination_show_total', {
              perpage: `${range[0]} - ${range[1]}`,
              total,
            })
        "
        show-size-changer
        :locale="{ items_per_page: $t('utils.items_per_page') }"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      />
    </a-col>

    <ModalProcessingState
      :show-modal="modalInformationProcessingState.show"
      :modal-information-processing-state="modalInformationProcessingState"
      @setModalInformationProcessingState="setModalInformationProcessingState"
      @triggerFulfillmentList="triggerFulfillmentList"
    />

    
    <a-modal
      :visible="showModalPrintLabel"
      :footer="null"
      class="modal-accept-order"
      @cancel="() => setShowModalPrintLabel({ show: false })"
    >
      <a-row>
        <a-col :span="24" class="d-flex justify-content-center">
          <div class="pbz-font subtitle-md-medium text-confirmation">
            {{ $t('fulfillment.printOrderLabel') }}
          </div>
        </a-col>

        <a-col :span="24" class="mt-3 d-flex justify-content-center">
          <div class="pbz-font text-caption">
            <div style="color: #999999">
              {{ $t('fulfillment.printLabelDesc') }}
            </div>
          </div>
        </a-col>

        <a-col
          :span="24"
          class="mt-5 d-flex justify-content-center align-items-center"
        >
          <div
            class="save pbz-font button-sm-medium d-flex justify-content-center align-items-center"
            style="
              border: 1px solid #e00000;
              background: #e00000;
              color: #ffffff;
              width: 100%;
              padding: 0.75rem;
              border-radius: 5px;
              cursor: pointer;
            "
            @click="toLabelPage(true)"
          >
            <div>
              <div>{{ $t('fulfillment.yesWithDetails') }}</div>
            </div>
          </div>
        </a-col>

        <a-col
          :span="24"
          class="d-flex justify-content-center align-items-center mt-2"
        >
          <a-button
            class="cancel pbz-font button-sm-medium"
            style="
              width: 100%;
              height: 100%;
              color: #e00000;
              padding: 0.75rem;
              cursor: pointer;
              border: 1px solid #e00000;
              border-radius: 5px;
            "
            @click.prevent="toLabelPage(false)"
          >
            {{ $t('fulfillment.noAddressOnly') }}
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
    <ModalExportData
      :visible="showModalExportData"
      :loading="loadingExportData"
      :do-state="categorie_state"
      :warehouses="warehouse_list"
      :services="service_list"
      @handleShowModal="handleShowModalExportData"
      @handleSubmitModal="onSubmitModalExportData"
    />
    <ModalBulkPrintShippingLabel
      :visible="showModalBulkPrintShippingLabel"
      :loading="loadingBulkPrintShippingLabel"
      :list-fulfillment="fulfillment"
      :action-type="typeActiveBulkActions"
      :business-id="businessId"
      @handleShowModal="handleShowModalBulkPrintShippingLabel"
      @handleSubmitModal="onSubmitModalBulkPrintShippingLabel"
    />
    <ModalConfirm
      :visible="showModalAccepted"
      :loading="loadingAccept"
      icon="check-circle"
      :title="$t('order.accept_confirm_msg')"
      :ok-label="$t('utils.yes')"
      :cancel-label="$t('utils.cancel')"
      @ok="onAcceptOrder"
      @cancel="onCloseModalAccept"
    >
      <div
        class="ant-alert ant-alert-error ant-alert-with-description ant-alert-no-icon py-2 mb-2 text-left"
      >
        <b>{{ $t('order.orderNumber') }}</b> : {{ dataAccepted.order_number }}
      </div>
    </ModalConfirm>
    <ModalCancelOrder
      ref="refModalCancelOrder"
      :visible="showModalCancelOrder"
      :loading="loadingCancelOrder"
      :data="dataCancelOrder"
      @cancel="closeModalCancelOrder"
      @ok="onSubmitCancelOrder"
    />
    <a-modal
      v-model="showModalTiktokError"
      :title="$t('utils.failed')"
      :footer="null"
      centered
    >
      <div class="text-center py-4">
        <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ff4d4f" style="font-size: 48px;" />
        <div class="mt-4 pbz-font body-md-regular">
          {{ tiktokErrorMessage }}
        </div>
      </div>
      <div class="text-right mt-4">
        <a-button type="primary" @click="showModalTiktokError = false">
          {{ $t('utils.close') }}
        </a-button>
      </div>
    </a-modal>
  </a-row>
</template>

<script>
import SearchIcon from '@/components/Icons/Search.vue'
import FilterIcon from '@/components/Icons/Filter.vue'
import FilterList from '@/components/Fulfillment/filter/index.vue'
import ModalProcessingState from '@/components/Fulfillment/ModalProcessingState/index.vue'
import { getExistingUrlFulfillment, getUrlAfterDetailFulfillment, getFallbackShippingLabelUrl } from '@/utils/fulfillment/index'
import ContentModalNotifToSetFilter from '@/components/Fulfillment/ContentModalNotifToSetFilter'
import FufillmentList from '@/components/Fulfillment/item/list.vue'
import LoadingListTable from '@/components/Loading/ListTable'
import ErrorInfo from '@/components/ErrorInfo'
import EmptyInfo from '@/components/EmptyInfo'
import debounce from 'lodash/debounce'
import getQueryParam from '@/utils/getQueryParam'
import ModalExportData from '@/views/fulfillment/ModalExportData.vue'
import ModalBulkPrintShippingLabel from '@/views/fulfillment/ModalBulkPrintShippingLabel.vue'
import { getFulfillmentViewList, getFulfillmentViewCount, getFulfillmentDetail, submitToWMS, bulkOrderProcess, exportFulfillmentList, checkRequestExportFulfillmentList } from '@/api/fulfillment'
import { shippingDelivered } from '@/api/shipping'
import { resynchronizeOrder } from '@/api/channels/index'
import { getAllWarehouseList } from '@/api/warehouse'
import ChannelsConstants from '@/constants/channels'
import ModalConfirm from '@/components/Modal/ModalConfirm.vue'
import ModalCancelOrder from '@/components/Fulfillment/Modal/ModalCancelOrder.vue'
import { processingOrder, processingOrderState, cancelOrderState } from '@/api/channels/index'
import { updatePackageTiktok } from '@/api/channels/tiktok'

const state = [
  {
    value: 'all',
    title: 'Semua',
  },
  {
    value: 'created,confirmed',
    title: 'Baru',
  },
  {
    value: 'accepted',
    title: 'Lakukan Proses',
  },
  {
    value: 'pick_confirmed',
    title: 'Pengambilan',
  },
  {
    value: 'packing_completed',
    title: 'Pengemasan',
  },
  
  
  
  
  {
    value: 'good_issued',
    title: 'Siap Kirim',
  },
  {
    value: 'shipped',
    title: 'Dalam Pengiriman',
  },
  {
    value: 'delivered,buyer_accepted',
    title: 'Terkirim',
  },
  {
    value: 'canceled,good_issued_canceled,deleted',
    title: 'Batal',
  },
  
  
  
  
]

const setTableWidth = () => {
  const { width } = window.screen
  return width < 821 ? 1190 : width - 343
}

export default {
  components: {
    SearchIcon,
    FilterIcon,
    FilterList,
    ContentModalNotifToSetFilter,
    ModalProcessingState,
    FufillmentList,
    LoadingListTable,
    EmptyInfo,
    ErrorInfo,
    ModalExportData,
    ModalBulkPrintShippingLabel,
    ModalConfirm,
    ModalCancelOrder,
  },
  mixins: [getQueryParam],
  data: function () {
    return {
      showModalPrintLabel: false,
      detailLabel: null,
      loadingList: true,
      loadingTotal: false,
      errorRows: false,
      isFetch: false,
      warehouseId: null,
      item_checked: [],
      all_item_checked: false,
      indeterminate_checked: false,
      indeterminate: false,
      checked_all: false,
      fulfillment: [],
      fulfillmentRAW: [],
      tempFulfillment: [],
      sizeOptions: ['10', '20', '30', '40', '50'],
      total_row: 0,
      total_box: 0,
      totalList: ['accepted', 'pick_confirmed', 'packing_completed', 'good_issued'],
      defaultTotal: {
        all: 0,
        created: 0,
        accepted: 0,
        pick_confirmed: 0,
        packing_completed: 0,
        good_issued: 0,
        shipped: 0,
        delivered: 0,
        canceled: 0,
      },
      total: {
        all: 0,
        created: 0,
        accepted: 0,
        pick_confirmed: 0,
        packing_completed: 0,
        good_issued: 0,
        shipped: 0,
        delivered: 0,
        canceled: 0,
      },
      filter: false,
      clear: false,
      position: {
        x: 0,
        y: 0,
      },
      warehouse_list: [],
      show_button_bulk: false,
      showModalNotifToSetFilter: false,
      orderIdToUpdated: null,
      timeout: 0,
      modalInformationProcessingState: {
        show: false,
        businessId: null,
        orderId: null,
        fulfillmentId: null,
        state: null,
        action: null,
      },
      isHaveActionButton: false,
      listWidth: setTableWidth(),
      flagResync: false,
      showModalExportData: false,
      loadingExportData: false,
      showModalBulkPrintShippingLabel: false,
      loadingBulkPrintShippingLabel: false,
      typeActiveBulkActions: null,
      bulkState: ['CREATED', 'CONFIRMED'],
      dataAccepted: {},
      showModalAccepted: false,
      loadingAccept: false,
      showModalCancelOrder: false,
      loadingCancelOrder: false,
      dataCancelOrder: {},
      showModalTiktokError: false,
      tiktokErrorMessage: '',
      fulfillment_ids: [],
      service_list: [
        // { label: 'INSTANT', value: 'INST' },
        // { label: 'EXPRESS', value: 'EXP' },
        // { label: 'REGULER', value: 'REG' },
        // { label: 'ECONOMY', value: 'ECO' },
        // { label: 'CARGO', value: 'TRK' },
        { value: '50', label: 'Instant Priority' },
        { value: '100', label: 'Instant' },
        { value: '200', label: 'Sameday 8 Hours' },
        { value: '300', label: 'Sameday' },
        { value: '400', label: 'Next Day Delivery' },
        { value: '500', label: 'Express' },
        { value: '600', label: 'Standard' },
        { value: '700', label: 'Economy' },
        { value: '800', label: 'Cargo' },
      ],
    }
  },
  computed: {
    isSuperAdmin() {
      return ["1a5e240b-535d-45c7-9646-b19b2047daa2", "30d9817c-07ef-45b8-a36c-319f86734b29", 'b7575f5b-1b45-4f53-b3fa-fccc9f7f1a42'].includes(this.$store.state.user.id)
    },
    businessList() {
      return this.$store.state.user.businessList
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : String(this.$route.query['business_id'] || Object.keys(this.$store.getters['user/businessListObjectByKey']))
    },
    activeCategories: function () {
      if (!this.$route.query.delivery_order_states) {
        return 'accepted'
      } else if (this.$route.query.delivery_order_states === 'trouble') {
        return 'trouble'
      }
      const find = this.categorie_state.find(item => item.value === this.$route.query.delivery_order_states)
      return find?.value
    },
    page: function () {
      return +this.$route.query.page || 1
    },
    limit: function () {
      return +this.$route.query.limit || 10
    },
    getPathUrl: function () {
      return getExistingUrlFulfillment({
        meta_key_url: this.$route.meta.key,
        id: this.$route.params.id,
        channel_type: this.$route.params.channelType,
      })
    },
    getFilterParam() {
      const warehouse = this.warehouseId
      if (
        this.$route.query.start_date ||
        this.$route.query.end_date ||
        this.$route.query.booking_state ||
        warehouse ||
        this.$route.query.service_type ||
        this.$route.query.channel_id
      ) {
        return true
      } else {
        return false
      }
    },
    getFulfillmentLengthEligibleBulkActions() {
      switch (this.typeActiveBulkActions) {
        case 'submit-to-wms':
          return this.fulfillment.filter(item => item.show_box).length
        case 'print-shipping-label':
          return this.fulfillment.filter(item => ['PICK_CONFIRMED', 'PACKING_COMPLETED', 'GOOD_ISSUED', 'SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'].includes(item?.delivery_order_state?.toUpperCase())).length
        case 'print-picking-list':
          return this.fulfillment.filter(item => !['CANCELED'].includes(item?.delivery_order_state?.toUpperCase())).length
        default:
          return this.fulfillment.length
      }
    },
    isIntermediateBulkActions() {
      if (this.getFulfillmentLengthEligibleBulkActions === this.fulfillment.filter(item => item.is_checked).length || this.fulfillment.filter(item => item.is_checked).length === 0) {
        return false
      }
      return true
    },
    isCheckedAllBulkActions() {
      const filteredData = this.getFulfillmentLengthEligibleBulkActions === this.fulfillment.filter(item => item.is_checked).length
      if (filteredData && this.getFulfillmentLengthEligibleBulkActions > 0) {
        return true
      }
      return false
    },

    activeFilter() {
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ]
      const bookingParam = this.$route.query.booking_state
        ? this.$route.query.booking_state.split(',')
        : null
      const warehouseParam = this.warehouseId
        ? this.warehouseId?.split(',')
        : null
      const channelParam = this.$route.query.channel_id
        ? this.$route.query.channel_id.split(',')
        : null
      const serviceTypeParam = this.$route.query.service_type
        ? this.$route.query.service_type.split(',')
        : null
      const start_date = this.$moment(this.$route.query.start_date).format(
        'DD MMM YYYY HH:mm:ss',
      )
      const end_date = this.$moment(this.$route.query.end_date).format(
        'DD MMM YYYY HH:mm:ss',
      )
      const date = this.$route.query.start_date
        ? [start_date, end_date].join(' - ')
        : null
      
      let booking_state = []
      if (bookingParam?.length) {
        bookingParam.forEach(booking => {
          const findBooking = this.inventory_state.find(state => state.value === booking)
          if (findBooking?.title) booking_state.push(findBooking.title)
        })
      }
      
      const warehouse_id = warehouseParam
        ? this.warehouse_list
            .filter(elem =>
              warehouseParam.find(item => (elem.id || elem.warehouse_id) === item),
            )
            .map(item => {
              return item.name
            })
        : []
      
      let channel_id = []
      if (channelParam?.length) {
        channelParam.forEach(channel => {
          const findChannel = this.$store.state.business.listChannels.find(ch => ch.id == channel)
          if (findChannel?.title) channel_id.push(findChannel.title)
        })
      }

      let service_type = []
      if (serviceTypeParam?.length) {
        serviceTypeParam.forEach(type => {
          const findService = this.service_list.find(service => service.value === type)
          if (findService?.label) service_type.push(findService.label)
        })
      }

      const activeValue = [
        ...booking_state,
        ...warehouse_id,
        ...channel_id,
        ...service_type,
        date,
      ]
      return activeValue.filter(item => item !== null)
    },
    isMasterFulfillment: function () {
      return (
        this.$route.meta.key === 'fulfillment' ||
        this.$route.meta.key === 'fulfillment-detail'
      )
    },
    getChannelCodeBasedOnroute() {
      const channel = this.$store.state.user.channelNavigation.find(
        item =>
          +item.id === +this.$route.params.id &&
          item.type === this.$route.params.channelType,
      )

      return channel ? channel.sales_channel_code : ''
    },
    getUrlAfterDetailFulfillmentPage: function () {
      return getUrlAfterDetailFulfillment({
        meta_key_url: this.$route.meta.key,
        id: this.$route.params.id,
        channel_type: this.$route.params.channelType,
      })
    },
    captionBulkyUpdate() {
      switch (this.activeCategories) {
        case 'created,confirmed': {
          return this.$t('fulfillment.accept')
        }

        case 'accepted': {
          return this.$t('fulfillment.picked')
        }

        case 'pick_confirmed': {
          return this.$t('fulfillment.packed')
        }

        case 'packing_completed': {
          return this.$t('fulfillment.shipped')
        }

        default:
          return ''
      }
    },
    categorie_state() {
      return [
        {
          value: 'all',
          title: this.$t('fulfillment.all'),
        },
        {
          value: 'created,confirmed',
          title: this.$t('fulfillment.new'),
        },
        {
          value: 'accepted',
          title: this.$t('fulfillment.do_process'),
        },
        {
          value: 'pick_confirmed',
          title: this.$t('fulfillment.picking'),
        },
        {
          value: 'packing_completed',
          title: this.$t('fulfillment.packing'),
        },
        {
          value: 'good_issued',
          title: this.$t('fulfillment.ready_to_ship'),
        },
        {
          value: 'shipped',
          title: this.$t('fulfillment.in_delivery'),
        },
        {
          value: 'delivered,buyer_accepted',
          title: this.$t('fulfillment.delivered'),
        },
        {
          value: 'canceled,good_issued_canceled,deleted',
          title: this.$t('fulfillment.canceled'),
        },
      ]
    },
    inventory_state() {
      return [
        {
          value: 'SUCCESS_ALLOCATED',
          title: this.$t('fulfillment.booked'),
          status: '',
        },
        {
          value: 'NOT_YET_ALLOCATED',
          title: this.$t('fulfillment.pending'),
          status: '',
        },
        {
          value: 'ALLOCATION_FAILED',
          title: this.$t('fulfillment.oos'),
          status: '',
        },
      ]
    },
    bulkDescription() {
      const msg = this.bulkState.includes('CREATED')
        ? this.$t('fulfillment.bulk_accepted_msg')
        : this.bulkState.includes('ACCEPTED')
        ? this.$t('fulfillment.bulk_picking_msg')
        : this.bulkState.includes('PICK_CONFIRMED')
        ? this.$t('fulfillment.bulk_packing_msg')
        : this.bulkState.includes('PACKING_COMPLETED')
        ? this.$t('fulfillment.bulk_good_issued_msg')
        : this.bulkState.includes('GOOD_ISSUED')
        ? this.$t('fulfillment.bulk_shipped_msg')
        : this.bulkState.includes('SHIPPED')
        ? this.$t('fulfillment.bulk_delivered_msg')
        : this.$t('fulfillment.processed')
      
      return {
          message: this.typeActiveBulkActions === 'bulk-process'
            ? msg
            : this.typeActiveBulkActions === 'submit-to-wms'
            ? this.$t('fulfillment.submit_to_wms_msg')
            : this.$t('fulfillment.printed_msg'),
          icon: this.typeActiveBulkActions === 'bulk-process'
            ? 'reconciliation'
            : this.typeActiveBulkActions === 'submit-to-wms'
            ? 'database'
            : 'printer',
          title: this.typeActiveBulkActions === 'bulk-process'
            ? this.$t('fulfillment.bulk_title', { action: msg })
            : this.typeActiveBulkActions === 'submit-to-wms'
            ? this.$t('fulfillment.submitToWms')
            : this.typeActiveBulkActions === 'print-picking-list'
            ? this.$t('fulfillment.print_picking_list')
            : this.$t('fulfillment.print_shipping_label'),
        }
    },
    bulkOrderState() {
      return this.bulkState
    },
    screenHeight() {
      return 'calc(100vh - 350px)'
    },
    permission() {
      return this.$store.getters['user/can']('fulfillment')
    },
    querySearch: {
      get() {
        return this.$route.query.q || this.$route.query.order_number_many || null
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    '$route.query.workspace_id'() {
      this.init()
    },
    '$route.query.business_id'() {
      this.fetchFulfillmentList()
    },
    '$route.query.warehouse_id'(value) {
      this.warehouseId = value
      this.fetchFulfillmentList()
    },
    '$route.query.whs_id'(value) {
      this.warehouseId = value
      this.fetchFulfillmentList()
    },
    '$route.query.channel_id'() {
      this.fetchFulfillmentList()
    },
    '$route.query.delivery_order_states'() {
      this.typeActiveBulkActions = null
      this.fetchFulfillmentList()
    },
    '$route.query.booking_state'() {
      this.fetchFulfillmentList()
    },
    '$route.query.start_date'() {
      this.fetchFulfillmentList()
    },
    '$route.query.end_date'() {
      this.fetchFulfillmentList()
    },
    'querySearch': {
      immediate: true,
      deep: true,
      handler: function (value) {
        this.fetchFulfillmentList()
      },
    },
    '$route.query.page'() {
      this.fetchFulfillmentList()
    },
    '$route.query.limit'() {
      this.fetchFulfillmentList()
    },
    '$route.query'() {
      this.all_item_checked = false
      this.indeterminate = false
      this.checked_all = false
      this.tempFulfillment = []
    },
    businessList: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (this.$store.state.user.restriction_base === 'Warehouse') {
          this.warehouse_list = this.$route.query.warehouse_id
            ? value?.filter(warehouse => warehouse.warehouse_id === this.$route.query.warehouse_id)
            : value
        }
      },
    },
    warehouseId: {
      deep: true,
      immediate: true,
      handler: function () {
        if (this.$store.state.user.restriction_base !== 'Warehouse') {
          this.fetchFulfillmentList()
        }
      },
    },
    item_checked: {
      deep: true,
      immediate: true,
      handler: function (value) {
        let countCreatedRow = 0

        value.forEach(item => {
          if (item.checked) {
            countCreatedRow++
          }
        })

        if (countCreatedRow > 0) {
          this.show_button_bulk = true
        } else {
          this.show_button_bulk = false
        }
      },
    },
    
    
    
    
    
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([
        this.fetchWarehouseList(),
        this.fetchFulfillmentList(),
      ])
    },
    setLoading(value) {
      this.loadingList = value
    },
    setWarehouseId(value) {
      this.warehouseId = value
    },
    fetchFulfillmentList: debounce(async function () {
      this.fulfillment_ids = []
      this.errorRows = false
      this.isFetch = false
      this.loadingTotal = true
      const isDelivered = this.$route.query.delivery_order_states === 'delivered,buyer_accepted'
      const q = this.$route.query.delivery_order_states?.toUpperCase()
      let defaultWarehouseId = this.$route.query.warehouse_id || this.$route.query.whs_id || this.warehouseId
      if (!defaultWarehouseId && this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse') {
        const warehouseRestrictionBase = this.businessList?.map((item) => item.warehouse_id)
        defaultWarehouseId = warehouseRestrictionBase?.length ? warehouseRestrictionBase.join(",") : null
      }
      const bookingState = this.$route.query?.booking_state?.split(',') || []
      const query = {
        ...this.$route.query,
        page: this.page,
        limit: this.limit,
        delivery_order_states: !q
          ? 'ACCEPTED'
          : q === 'TROUBLE' || q === 'ALL'
          ? undefined
          : q,
        warehouse_id: defaultWarehouseId,
        whs_id: undefined,
        check_trouble_do: q === 'TROUBLE' ? true : undefined,
        service_type: undefined,
        fulfillment_priority_level: this.$route.query.service_type,
        booking_state: !bookingState.length
          ? undefined
          : bookingState.length && bookingState.includes('SUCCESS_ALLOCATED')
          ? bookingState.join() + ',ALLOCATED'
          : bookingState.join(),
      }
      if (this.$route.params.channelType && +this.$route.params.id) {
        query[this.$route.params.channelType] = +this.$route.params.id
      }

      await getFulfillmentViewList(query)
      .then(async ({ data: { data: response } }) => {
        this.fulfillment = []
        this.fulfillmentRAW = []
        this.total_box = 0
        response?.forEach(item => {
          if (
            item.is_ext_wms &&
            !item.channel_is_wms_auto_submit &&
            !item.is_wms_submitted &&
            (item.delivery_order_state === 'ACCEPTED' ||
              ((item.delivery_order_state === 'CREATED' || item.delivery_order_state === 'CONFIRMED') &&
                item.order_state === 'ACCEPTED'))
          ) {
            item.show_box = true
            item.is_checked = false
          }
          this.fulfillment.push(item)
          this.fulfillmentRAW.push(item)
          if (item?.show_box) this.total_box++
        })

        if (Array.isArray(this.fulfillment) && this.fulfillment.length > 0) {
          this.item_checked = this.fulfillment.map(item => ({
            business_id: item.business_id,
            order_id: item.order_id,
            fulfillment_id: item.fulfillment_id,
            checked: false,
            delivery_order_state: item.delivery_order_state,
          }))
        }

        this.loadingList = false
        this.isFetch = true
        this.total = JSON.parse(JSON.stringify(this.defaultTotal))
        await getFulfillmentViewCount(query)
        .then(({ data: res }) => {
          if (res?.length) {
            res.forEach(r => {
              if (['CREATED', 'CONFIRMED'].includes(r.state)) {
                this.total.created += r.total
                this.total.all += r.total
              } else if (['ACCEPTED'].includes(r.state)) {
                this.total.accepted += r.total
                this.total.all += r.total
              } else if (['PICK_CONFIRMED'].includes(r.state)) {
                this.total.pick_confirmed += r.total
                this.total.all += r.total
              } else if (['PACKING_COMPLETED'].includes(r.state)) {
                this.total.packing_completed += r.total
                this.total.all += r.total
              } else if (['GOOD_ISSUED'].includes(r.state)) {
                this.total.good_issued += r.total
                this.total.all += r.total
              } else if (['SHIPPED'].includes(r.state)) {
                this.total.shipped += r.total
                this.total.all += r.total
              } else if (['DELIVERED', 'BUYER_ACCEPTED'].includes(r.state)) {
                this.total.delivered += r.total
                this.total.all += r.total
              } else if (['CANCELED', 'GOOD_ISSUED_CANCELED', 'DELETED']) {
                this.total.canceled += r.total
                this.total.all += r.total
              }
            })
          }
        })
        .finally(() => {
          this.total_row = this.total[this.activeCategories?.split(',')?.[0]] || 0
          this.loadingTotal = false
        })
      })
      .catch(err => {
        this.errorRows = err.response.status
        this.total = JSON.parse(JSON.stringify(this.defaultTotal))
        this.loadingList = false
        this.isFetch = true
        console.error(err)
      })
    }, 500),
    changeCategorieState: function (value) {
      this.loadingList = true
      this.$router.push({
        path: this.getPathUrl,
        query: {
          ...this.$route.query,
          delivery_order_states: value,
          fulfillment_id: undefined,
          page: 1,
        },
      })
    },
    checkboxSelectAllFulfillment: function (e) {
      this.item_checked = this.item_checked.map(item => ({
        ...item,
        checked: e.target.checked,
      }))
      this.all_item_checked = e.target.checked
      this.indeterminate_checked = false
    },
    getItemChecked: function (order_id) {
      const data = this.item_checked.find(item => item.order_id === order_id)
      return data ? data.checked : false
    },
    checkboxSelectAllSubmitted(event) {
      this.checked_all = event.target.checked
    },
    onCheckBulkActions(obj) {
      const currentTypeActiveBulkActions = this.typeActiveBulkActions
      switch (currentTypeActiveBulkActions) {
        case 'submit-to-wms':
          this.handleItemSubmitted(obj)
          break
        case 'print-shipping-label':
        case 'bulk-process':
        case 'print-picking-list':
          this.fulfillment[obj.index].is_checked = obj.checked
          if (obj.checked) {
            this.fulfillment_ids.push(this.fulfillment[obj.index].fulfillment_id)
          } else {
            const index = this.fulfillment_ids.indexOf(this.fulfillment[obj.index].fulfillment_id)
            if (index > -1) this.fulfillment_ids.splice(index, 1)
          }
          break
        default:
          this.$notification.error({
            message: 'Checkbox Bulk Actions Gagal',
            description: 'Mohon hubungi Admin terkait kendala Bulk Actions',
          })
          this.typeActiveBulkActions = ''
          break
      }
    },
    onCheckAllBulkActions(value) {
      let count = 0
      const currentTypeActiveBulkActions = this.typeActiveBulkActions
      switch (currentTypeActiveBulkActions) {
        case 'submit-to-wms':
          this.fulfillment.forEach((item, index) => {
            if (item.show_box) {
              this.handleItemSubmitted({
                index,
                checked: value.target.checked,
                item,
              })
            }
          })
          break
        case 'print-shipping-label':
          const tempData = this.fulfillment.map((item) => {
            if (['PICK_CONFIRMED', 'PACKING_COMPLETED', 'GOOD_ISSUED', 'SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'].includes(item?.delivery_order_state?.toUpperCase())) {
              if (count == 0) this.fulfillment_ids = []
              if (value.target.checked) this.fulfillment_ids.push(item.fulfillment_id)
              count++
              return {
                ...item,
                is_checked: value.target.checked,
              }
            } else {
              return item
            }
          })
          this.fulfillment = tempData
          break
        case 'bulk-process':
          const dataTemp = this.fulfillment.map((item) => {
            if (['CREATED', 'CONFIRMED'].includes(item?.delivery_order_state?.toUpperCase()) || (!item.is_ext_wms && ['ACCEPTED', 'PICK_CONFIRMED', 'PACKING_COMPLETED'].includes(item?.delivery_order_state?.toUpperCase()))) {
              if (count == 0) this.fulfillment_ids = []
              if (value.target.checked) this.fulfillment_ids.push(item.fulfillment_id)
              count++
              return {
                ...item,
                is_checked: value.target.checked,
              }
            } else {
              return item
            }
          })
          this.fulfillment = dataTemp
          break
        case 'print-picking-list':
          const dataTmp = this.fulfillment.map((item) => {
            if (!['CANCELED'].includes(item?.delivery_order_state?.toUpperCase())) {
              if (count == 0) this.fulfillment_ids = []
              if (value.target.checked) this.fulfillment_ids.push(item.fulfillment_id)
              count++
              return {
                ...item,
                is_checked: value.target.checked,
              }
            } else {
              return item
            }
          })
          this.fulfillment = dataTmp
          break
        default:
          this.$notification.error({
            message: 'Check All Bulk Actions Gagal',
            description: 'Mohon hubungi Admin terkait kendala Bulk Actions',
          })
          this.typeActiveBulkActions = ''
          break
      }
    },
    handleItemSubmitted(obj) {
      this.fulfillment[obj.index].is_checked = obj.checked
      const index = this.tempFulfillment.findIndex(
        fulfillment => fulfillment.id === obj.item.fulfillment_id,
      )
      if (obj.checked && index < 0) {
        const {
          fulfillment_id,
          order_id,
          order_number,
          channel_id,
          warehouse_id,
          channel_code,
        } = obj.item
        const findWarehouse = this.warehouse_list.find(
          warehouse => warehouse.id === warehouse_id,
        )
        this.fulfillment_ids.push(fulfillment_id)
        this.tempFulfillment.push({
          id: fulfillment_id,
          order_id,
          order_number,
          channel_id,
          warehouse_id,
          wms_code: findWarehouse?.wms_code || '',
          channel_code,
        })
      } else if (!obj.checked && index > -1) {
        const idx = this.fulfillment_ids.indexOf(obj.item.fulfillment_id)
        if (idx > -1) this.fulfillment_ids.splice(idx, 1)
        this.tempFulfillment.splice(index, 1)
      }

      this.indeterminate =
        this.tempFulfillment.length > 0 &&
        this.tempFulfillment.length < this.total_box
      this.checked_all = this.tempFulfillment.length == this.total_box
    },
    async handleBulkActions() {
      if(this.typeActiveBulkActions === 'bulk-process') {
        this.handleBulkProcess()
      } else if(this.typeActiveBulkActions === 'print-shipping-label' || this.typeActiveBulkActions === 'print-picking-list') {
        this.handleBulkPrintShippingLabel()
      } else if(this.typeActiveBulkActions === 'submit-to-wms') {
        this.handleSubmitToWms()
      }
    },
    async handleBulkProcess() {
      this.loadingList = true
      const { fulfillment_ids } = this
      let msg = '';
      if (this.bulkState.includes('CREATED')) {
          msg = 'Accepted';
      } else if (this.bulkState.includes('ACCEPTED')) {
          msg = 'Picking';
      } else if (this.bulkState.includes('PICK_CONFIRMED')) {
          msg = 'Packing';
      } else if (this.bulkState.includes('PACKING_COMPLETED')) {
          msg = 'Good Issued';
      } else if (this.bulkState.includes('GOOD_ISSUED')) {
          msg = 'Shipped';
      } else if (this.bulkState.includes('SHIPPED')) {
          msg = 'Delivered';
      } else if (this.bulkState.includes('BUYER_ACCEPTED')) {
          msg = 'Buyer Accepted';
      }

      if (this.bulkState.includes('CREATED')) {
        let promises = []
        this.fulfillment_ids.forEach(fulfillment_id => {
          const findFulfillment = this.fulfillment.find(item => item.fulfillment_id == fulfillment_id)
          if (findFulfillment?.order_number) {
            if (ChannelsConstants.includes(findFulfillment.channel_code)) {
              promises.push(
                processingOrder({
                  business_id: findFulfillment.business_id,
                  processType: 'state',
                  id: findFulfillment.order_id,
                  channel_id: findFulfillment.channel_id,
                  channel_code: findFulfillment.channel_code === 'distributor_redeem'
                    ? 'distributor'
                    : findFulfillment.channel_code,
                  new_status: 'ACCEPTED',
                  order_number: findFulfillment.order_number,
                })
                .then(() => ({ status: 'success', order_number: findFulfillment.order_number }))
                .catch(() => ({ status: 'failed', order_number: findFulfillment.order_number })),
              )
              
            } else {
              promises.push(
                processingOrderState({
                  business_id: findFulfillment.business_id,
                  order_id: findFulfillment.order_id,
                  order_number: findFulfillment.order_number,
                  data: {
                    new_status: 'ACCEPTED',
                    reason_code: '',
                    reason: '',
                    oos_line_item_ids: [],
                    channel: {
                      id: findFulfillment.channel_id,
                      code: findFulfillment.channel_code,
                    },
                  },
                })
                .then(() => ({ status: 'success', order_number: findFulfillment.order_number }))
                .catch(() => ({ status: 'failed', order_number: findFulfillment.order_number })),
              )
            }
          }
        })

        await Promise.allSettled(promises)
        .then(response => {
          let failed = []
          response?.forEach(res => {
            if (res.value.status === 'failed') {
              failed.push(res.value.order_number)
            }
          })
          
          const type = failed.length ? 'error' : 'success'
          this.$notification[type]({
            message: `Bulk ${msg} ${failed.length ? 'Gagal' : 'Berhasil'}`,
            description: failed.length
              ? `Order Number: ${failed.join(', ')} gagal. Mohon hubungi Admin terkait kendala Bulk Process`
              : 'Apabila data fulfillment belum berubah, mohon tunggu beberapa saat dan refresh ulang data fulfillment',
          })

          this.indeterminate = false
          this.checked_all = false
          this.tempFulfillment = []
        })
        .catch(err => {
          this.$notification.error({
            message: `Bulk ${msg} Gagal`,
            description: 'Mohon hubungi Admin terkait kendala Bulk Process',
          })
          console.error(err)
        })
        .finally(() => {
          this.fetchFulfillmentList()
          this.loadingList = false
        })
      } else if (this.bulkState.includes('GOOD_ISSUED') || this.bulkState.includes('SHIPPED') || this.bulkState.includes('DELIVERED')) {
        const state = this.bulkState.includes('GOOD_ISSUED')
          ? 'shipped'
          : this.bulkState.includes('SHIPPED')
          ? 'delivered'
          : 'buyer_accepted'
        
        const order_ids = this.fulfillment.filter(item => fulfillment_ids.includes(item.fulfillment_id))?.map(item => item.order_id)
        
        await shippingDelivered({
          state,
          data: {
            business_id: this.businessId,
            order_id: order_ids,
          },
        })
        .then(() => {
          this.indeterminate = false
          this.checked_all = false
          this.tempFulfillment = []
          this.$notification.success({
            message: `Bulk ${msg} Berhasil`,
            description:
              'Apabila data fulfillment belum berubah, mohon tunggu beberapa saat dan refresh ulang data fulfillment',
          })
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$notification.error({
            message: `Bulk ${msg} Gagal`,
            description: 'Mohon hubungi Admin terkait kendala Bulk Process',
          })
          console.error(err)
        })
        .finally(() => (this.loadingList = false))
      } else {
        await bulkOrderProcess({
          business_id: this.businessId,
          state: this.bulkState.includes('ACCEPTED')
            ? 'PICK_CONFIRMED'
            : this.bulkState.includes('PICK_CONFIRMED')
            ? 'PACKING_COMPLETED'
            : 'GOOD_ISSUED',
          data: { fulfillment_ids },
        })
        .then(() => {
          this.indeterminate = false
          this.checked_all = false
          this.tempFulfillment = []
          this.$notification.success({
            message: `Bulk ${msg} Berhasil`,
            description:
              'Apabila data fulfillment belum berubah, mohon tunggu beberapa saat dan refresh ulang data fulfillment',
          })
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$notification.error({
            message: `Bulk ${msg} Gagal`,
            description: 'Mohon hubungi Admin terkait kendala Bulk Process',
          })
          console.error(err)
        })
        .finally(() => (this.loadingList = false))
      }
    },
    async handleSubmitToWms() {
      this.loadingList = true
      await submitToWMS({
        business_id: this.businessId,
        data: {
          data: this.tempFulfillment,
        },
      })
        .then(() => {
          this.indeterminate = false
          this.checked_all = false
          this.tempFulfillment = []
          this.$notification.success({
            message: 'Submit Berhasil',
            description:
              'Apabila data fulfillment belum berubah, mohon tunggu beberapa saat dan refresh ulang data fulfillment',
          })
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$notification.error({
            message: 'Submit Gagal',
            description: 'Mohon hubungi Admin terkait kendala Submit to WMS',
          })
          console.error(err)
        })
        .finally(() => (this.loadingList = false))
    },
    handleBulkPrintShippingLabel() {
      if (this.fulfillment.filter(item => item.is_checked).length === 0) {
        const label = this.typeActiveBulkActions === 'print-picking-list'
          ? 'Picking List'
          : 'Shipping Label'
        return this.$notification.warning({
          message: `Cetak ${label} Gagal`,
          description: `Mohon pilih minimal 1 order yang akan dicetak ${label.toLowerCase()}`,
        })
      }
      this.showModalBulkPrintShippingLabel = true
    },
    onCancelBulkActions() {
      this.typeActiveBulkActions = null
      this.fulfillment_ids = []
      this.fulfillment = this.fulfillment.map((item) => {
        return {
          ...item,
          is_checked: false,
        }
      })
    },
    handleItemChecked: function ({ checked, order_id }) {
      this.item_checked = this.item_checked.map(item => {
        if (item.order_id === order_id) {
          return {
            ...item,
            checked,
          }
        } else {
          return item
        }
      })

      let countItemSelected = 0

      this.item_checked.forEach(item => {
        if (item.checked) countItemSelected++
      })

      if (countItemSelected === this.item_checked.length) {
        this.all_item_checked = true
        this.indeterminate_checked = false
      }

      if (
        countItemSelected > 0 &&
        countItemSelected !== this.item_checked.length
      ) {
        this.indeterminate_checked = true
        this.all_item_checked = false
      }

      if (countItemSelected === 0) {
        this.all_item_checked = false
        this.indeterminate_checked = false
      }
    },
    changePage: function (value) {
      this.loadingList = true
      this.$router.push({
        path: this.getPathUrl,
        query: {
          ...this.$route.query,
          page: value,
          order_id: undefined,
          fulfillment_id: undefined,
        },
      })
    },
    onShowSizeChange(current, pageSize) {
      this.loadingList = true
      this.$router.push({
        path: this.getPathUrl,
        query: {
          ...this.$route.query,
          page: current,
          limit: pageSize,
          order_id: undefined,
          fulfillment_id: undefined,
        },
      })
    },
    handleFilter() {
      if (this.filter === true) {
        this.filter = false
      } else {
        this.filter = true
      }
    },
    cancelModal(e) {
      this.filter = e
    },
    resetFilter() {
      this.loadingList = true
      let temp = {
        ...this.$route.query,
        booking_state: undefined,
        whs_id: undefined,
        channel_id: undefined,
        start_date: undefined,
        end_date: undefined,
        service_type: undefined,
      }
      this.warehouseId = null
      this.clear = !this.clear
      this.$router.push({
        path: this.getPathUrl,
        query: temp,
      })
    },
    handleOnClickButtonExoport: function () {
      if (!this.activeFilter.length) {
        this.showModalNotifToSetFilter = true
      }
    },
    async fetchWarehouseList() {
      if (this.$store.state.user.restriction_base?.toLowerCase() !== 'warehouse') {
        const { business_id } = this.$route.query
        let defaultBusinessId = business_id || this.businessId
        if (Array.isArray(defaultBusinessId) && defaultBusinessId.length > 0) {
          defaultBusinessId = defaultBusinessId.join(',')
        }
        const params = { business_id: defaultBusinessId }
        try {
          this.warehouse_list = await getAllWarehouseList(params)
        } catch (err) {
          console.error(err)
        }
      }
    },
    exportHistory() {
      this.$router.push({
        path: 'fulfillment/export',
      })
    },
    setOrderIdToUpdated(value) {
      this.orderIdToUpdated = value
    },
    handleButtonAcceptBulkOrder() {
      let action

      switch (this.activeCategories) {
        case 'created,confirmed': {
          action = 'accept-order'
          break
        }

        case 'accepted': {
          action = 'pick-confirmed'
          break
        }

        case 'pick_confirmed': {
          action = 'pack-confirmed'
          break
        }

        case 'packing_completed': {
          action = 'packing-completed'
          break
        }

        default:
          break
      }

      this.modalInformationProcessingState = {
        show: true,
        businessId: this.item_checked.map(item => item.business_id),
        orderId: this.item_checked.map(item => item.order_id),
        fulfillmentId: this.item_checked.map(item => item.fulfillment_id),
        state: '',
        action,
        channelCode: this.getChannelCodeBasedOnroute,
      }
    },
    handleSearch: debounce(function (e) {
      this.loadingList = true
      const value = e.target.value
      return this.$router.push({
        path: this.isMasterFulfillment
          ? '/fulfillment'
          : `/channel/${this.$route.params.id}/${this.$route.params.channelType}/fulfillment`,
        query: {
          ...this.getQueryParam(this.$route.query),
          delivery_order_states: 'all',
          q: value.includes(',') || !value ? undefined : value,
          order_number_many: value.includes(',') || value.includes(';') ? value : undefined,
          page: 1,
        },
      })
    }, 1000),
    setModalInformationProcessingState(value) {
      this.modalInformationProcessingState = value
    },
    setHaveActionButton(value) {
      this.isHaveActionButton = value
    },
    triggerFulfillmentList() {
      this.fetchFulfillmentList()
    },
    async setShowModalPrintLabel(value) {
      this.loadingList = true
      if (value.show) {
        await getFulfillmentDetail({
          url: 'fulfillment',
          fulfillment_id: value.fulfillmentId,
        })
        .then(({ data: { data: response } }) => {
          if (response.order.channel.code === 'tokopedia_id') {
            if (
              (!response?.fulfillments?.[0]?.shipping.awb ||
                !response?.fulfillments?.[0]?.shipping.courier ||
                !response?.fulfillments?.[0]?.shipping.shipping_label_url) &&
              !this.flagResync
            ) {
              this.resychronizeShipping(
                response.order.id,
                response.order.channel.code,
                value,
              )
            } else {
              this.flagResync = false
              if (response?.fulfillments?.[0]?.shipping?.shipping_label_url) {
                this.detailLabel = value
                window.open(response.fulfillments[0]?.shipping.shipping_label_url, '_blank');
              } else {
                this.showModalPrintLabel = value.show
                this.detailLabel = value
              }
              this.loadingList = false
            }
          } else {
            if (response?.fulfillments?.[0]?.shipping?.shipping_label_url) {
              this.detailLabel = value
              window.open(response.fulfillments[0]?.shipping.shipping_label_url, '_blank');
            } else {
              const fallbackUrl = getFallbackShippingLabelUrl({
                channelCode: response?.order?.channel?.code || response?.channel_code || value.channelCode,
                businessId: value.businessId || response?.business_id || response?.order?.business_id || this.$route.query.business_id,
                orderNumber: response?.order?.order_number || response?.order_number || value.orderNumber,
              })

              if (fallbackUrl) {
                this.detailLabel = value
                window.open(fallbackUrl, '_blank')
              } else {
                this.showModalPrintLabel = value.show
                this.detailLabel = value
              }
            }
            this.loadingList = false
          }
        })
        .catch(err => {
          this.loadingList = false
          console.error(err)
          this.$notification.error({
            message: 'Maaf, Label Belum Tersedia',
          })
        })
      } else {
        this.showModalPrintLabel = value.show
        this.loadingList = false
      }
    },
    async resychronizeShipping(order_id, channelCode, val) {
      this.loadingList = true
      await resynchronizeOrder({
        business_id: this.$route.query.business_id,
        channel_code: channelCode,
        order_id: order_id,
      })
      .then(() => this.loadingList = true)
      .catch(err => {
        console.error('errornya', err)
        this.loadingList = true
      })
      .finally(() => {
        this.flagResync = true
        setTimeout(() => {
          this.setShowModalPrintLabel(val)
        }, 3000)
      })
    },
    toLabelPage(param) {
      this.$router.push({
        name:
          this.$route.params.id === undefined
            ? 'fulfillment-label'
            : 'channel-fulfillment-label',
        query: {
          ...this.getQueryParam(this.$route.query),
          delivery_order_states: 'all',
          order_id: this.detailLabel.orderId,
          fulfillment_id: this.detailLabel.fulfillmentId,
        },
        params: {
          label_product: param,
        },
      })
    },
    handleShowModalExportData(param) {
      this.showModalExportData = param
    },
    onSubmitModalExportData(params) {
      this.loadingExportData = true
      this.onExportFulfillmentList(params)
    },
    handleShowModalBulkPrintShippingLabel(param) {
      this.showModalBulkPrintShippingLabel = param
    },
    onSubmitModalBulkPrintShippingLabel(fulfillment_ids) {
      const path = this.typeActiveBulkActions === 'print-picking-list'
        ? '/fulfillment/bulk-picking-list'
        : '/fulfillment/bulk-shipping-label'
      const currentRouterQuery = this.$route.query
      const newPath = {
        path,
        query: {
          ...currentRouterQuery,
          fulfillment_id: fulfillment_ids,
          restriction_base: this.$store.state.user.restriction_base.toLowerCase(),
        },
      }
      const fullUrl = this.$router.resolve(newPath).href
      window.open(fullUrl, '_blank')
      this.fulfillment = this.fulfillment.map((item) => {
        return {
          ...item,
          is_checked: false,
        }
      })
    },
    onClickAccepted(val) {
      this.dataAccepted = val
      this.showModalAccepted = true
    },
    onCloseModalAccept() {
      this.showModalAccepted = false
      this.dataAccepted = {}
    },
    async onAcceptOrder() {
      let business_id = this.$route.query.business_id
      if (!business_id) {
        business_id = this?.businessList?.find(
          val => val.warehouse_id === this.$route.query?.whs_id,
        )?.business_id
      }

      this.loadingAccept = true
      const channel_code = this.dataAccepted.channel_code
      if (ChannelsConstants.includes(channel_code)) {
        await processingOrder({
          business_id: this.dataAccepted.business_id,
          processType: 'state',
          id: this.dataAccepted.order_id,
          channel_id: this.dataAccepted.channel_id,
          channel_code: channel_code === 'distributor_redeem'
            ? 'distributor'
            : channel_code,
          new_status: 'ACCEPTED',
          order_number: this.dataAccepted.order_number,
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.onCloseModalAccept()
          this.fetchFulfillmentList()
        })
        .catch(err => {
          if (['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(channel_code) && err?.response?.data?.message) {
            this.onCloseModalAccept()
            this.tiktokErrorMessage = err.response.data.message
            this.showModalTiktokError = true
          } else {
            this.$message.error(err?.response?.data?.message || err.message)
          }
        })
        .finally(() => {
          this.loadingAccept = false
        })
      } else {
        await processingOrderState({
          business_id: this.dataAccepted.business_id,
          order_id: this.dataAccepted.order_id,
          order_number: this.dataAccepted.order_number,
          data: {
            new_status: 'ACCEPTED',
            reason_code: '',
            reason: '',
            oos_line_item_ids: [],
            channel: {
              id: this.dataAccepted.channel_id,
              code: this.dataAccepted.channel_code,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.onCloseModalAccept()
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingAccept = false
        })
      }
    },
    onClickRevision(val) {
      this.$router.push({
        path: `/fulfillment/${val.fulfillment_id}/revision`,
        query: {
          ...this.$route.query,
          business_ids: val.business_id,
          sla: val.sla,
        },
      })
    },
    onClickCancelOrder(val) {
      this.dataCancelOrder = val
      this.showModalCancelOrder = true
    },
    async onClickUpdatePackage(item) {
      try {
        await updatePackageTiktok({
          params: {
            id: item.order_id,
            channel_id: item.channel_id,
          },
        })
        this.$notification.success({
          message: this.$t('fulfillment.update_package_success'),
        })
        this.triggerFulfillmentList()
      } catch (err) {
        this.$notification.error({
          message: err?.response?.data?.message || this.$t('fulfillment.update_package_failed'),
        })
      }
    },
    closeModalCancelOrder() {
      this.showModalCancelOrder = false
      this.dataCancelOrder = {}
    },
    async onSubmitCancelOrder(values) {
      this.loadingCancelOrder = true
      const { index_reason_code, ...restValues } = values
      if (ChannelsConstants.includes(this.dataCancelOrder.channel_code)) {
        await processingOrder({
          business_id: this.dataCancelOrder.business_id,
          processType: 'cancel',
          id: this.dataCancelOrder.order_id,
          channel_code: this.dataCancelOrder.channel_code === 'distributor_redeem'
            ? 'distributor'
            : this.dataCancelOrder.channel_code,
          new_status: 'CANCELED',
          order_number: this.dataCancelOrder.order_number,
          ...values,
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully cancel order')
          this.closeModalCancelOrder()
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      } else if (this.$store.state.user?.listChannelOffline?.includes(this.dataCancelOrder.channel_code)) {
        cancelOrderState({
          business_id: this.dataCancelOrder.business_id,
          order_id: this.dataCancelOrder.order_id,
          order_number: this.dataCancelOrder.order_number,
          data: {
            new_status: 'CANCELED',
            reason_code: index_reason_code,
            reason: values?.reason,
            channel: {
              id: this.dataCancelOrder?.channel_id,
              code: this.dataCancelOrder?.channel_code,
              name: this.dataCancelOrder?.channel_name,
              
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.closeModalCancelOrder()
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      } else {
        await processingOrderState({
          business_id: this.dataCancelOrder.business_id,
          order_id: this.dataCancelOrder.order_id,
          order_number: this.dataCancelOrder.order_number,
          data: {
            new_status: 'CANCELED',
            reason_code: '',
            reason: '',
            oos_line_item_ids: [],
            channel: {
              id: this.dataCancelOrder.channel_id,
              code: this.dataCancelOrder.channel_code,
            },
          },
        })
        .then(res => {
          this.$message.success(res?.data?.message || 'Successfully updated state')
          this.closeModalCancelOrder()
          this.fetchFulfillmentList()
        })
        .catch(err => {
          this.$message.error(err?.response?.data?.message || err.message)
        })
        .finally(() => {
          this.loadingCancelOrder = false
        })
      }
    },
    onExportFulfillmentList: debounce(async function(params) {
      const { workspace_id, business_id } = this.$route.query
      const { delivery_order_states, booking_state, warehouse_id, channel_id, service_type, start_date, end_date, order_date } = params
      await exportFulfillmentList({
        workspace_id,
        business_id: (this.$store.state.user.restriction_base?.toLowerCase() !== 'warehouse' && !business_id) || this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse'
          ? this.businessId
          : business_id,
        delivery_order_states: !delivery_order_states || delivery_order_states.includes('all')
          ? undefined
          : delivery_order_states.join().toUpperCase(),
        booking_state: !booking_state.length || booking_state.includes('all')
          ? undefined
          : booking_state.length && booking_state.includes('SUCCESS_ALLOCATED')
          ? booking_state.join() + ',ALLOCATED'
          : booking_state.join(),
        warehouse_id: this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse' && this.$route.query.warehouse_id
          ? this.$route.query.warehouse_id
          : this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse' && (!warehouse_id.length || warehouse_id.includes('all'))
          ? this.businessList?.map((item) => item.warehouse_id)?.join()
          : this.$store.state.user.restriction_base?.toLowerCase() !== 'warehouse' && (!warehouse_id.length || warehouse_id.includes('all'))
          ? undefined
          : warehouse_id.join(),
        channel_id: !channel_id.length || channel_id.includes('all')
          ? undefined
          : channel_id.join(),
        fulfillment_priority_level: !service_type.length || service_type.includes('all')
          ? undefined
          : service_type.join(),
        start_date: !order_date.length
          ? undefined
          : this.$moment(start_date).format(),
        end_date: !order_date.length
          ? undefined
          : this.$moment(end_date).format(),
      })
      .then(({ data }) => this.onResponseExportFulfillmentList(data))
      .catch(() => this.onErrorExportFulfillmentList())
    }, 500),
    getProcessExportFulfillmentList: debounce(async function(request_id) {
      await checkRequestExportFulfillmentList({
        request_id,
        params: {
          process_name: 'EXPORT_DO',
        },
      })
      .then(({ data }) => this.onResponseExportFulfillmentList(data))
      .catch(() => this.onErrorExportFulfillmentList())
    }, 10000),
    onResponseExportFulfillmentList(data) {
      if (data?.status === 'FAILED') {
        this.onErrorExportFulfillmentList()
      } else if (data?.status === 'FINISHED') {
        if (data?.url) {
          this.loadingExportData = false
          window.location.href = data.url
        } else {
          this.onErrorExportFulfillmentList()
        }
      } else {
        this.getProcessExportFulfillmentList(data.request_id)
      }
    },
    onErrorExportFulfillmentList() {
      this.$notification.error({
        message: 'Export Data Gagal',
        description: 'Export Data Delivery Order gagal',
      })
      this.loadingExportData = false
    },
  },
}
</script>

<style lang="scss" scoped>
.row-calc > .col {
  padding-left: 9px;
  padding-right: 9px;
  flex-basis: calc(100% / 6); 
  max-width: calc(100% / 6);
  font-size: 13px;
}

.col-10p {
  flex-basis: 10%;
  max-width: 10%;
  font-size: 13px;
}

.salesindex {
  font-family: 'Poppins', sans-serif !important;
  font-style: normal;

  .categories {
    .list {
      color: #999;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 2px 14px;
      min-height: 30px;
      background: #fff;
    }

    .list:not(:focus) {
      border-color: #999;
    }

    .active {
      background: #4d4d4d;
      color: #fff;
      border-color: #4d4d4d;
    }

    .list:hover:not(.active) {
      border-color: #4d4d4d;
      color: #4d4d4d;
    }
  }

  .active {
    background: #0559cb;
    color: #fff;
    border: 1px solid #0559cb;
  }
}
</style>

<style lang="scss">
.fulfillment {
  font-family: 'Poppins', sans-serif !important;
  font-style: normal;

  .search-box {
    width: 338px;
  }
  .field {
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
    text-align: left;
    padding-left: 2.5rem !important;
    padding: 10px 15px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    border-radius: 5px;
    color: #999999;
  }
  .search-box > .i {
    position: absolute;
    margin: 0.5rem 0 0 0.5rem;
  }
  .field::placeholder {
    color: #999999 !important;
  }

  .filter-box {
    width: 93px;
    height: 40px;
    padding: 2px;
    background: #ffffff;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    div {
      margin: 0 5px;
    }

    .caption {
      font-family: 'Poppins', sans-serif !important;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #999999;
    }
  }

  .empty {
    .caption-one {
      margin-top: 60px;
      color: #1a1a1a;
    }

    .caption-two {
      margin-top: 10px;
      color: #999999;
    }

    .button-reload {
      padding: 12px 20px;
      position: static;
      width: 401px;
      height: 48px;
      background: #0559cb;
      border-radius: 5px;
      color: #ffffff;
      margin-top: 50px;
      cursor: pointer;
    }
  }

  .categories {
    margin-top: 30px;
    cursor: pointer;

    .list {
      margin: 0px 2px 6px;
      color: #999999;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      width: auto;
      height: 31px;
      background: #ffffff;
      border: 1px solid #999999;
      box-sizing: border-box;
      border-radius: 33px;
      p {
        margin: 0;
        font-size: 0.9em;
      }
    }

    .active {
      background: #4d4d4d;
      color: #ffffff;
      border: 1px solid #4d4d4d;
    }

    .list:hover:not(.active) {
      border: 1px solid #4d4d4d;
      color: #4d4d4d;
    }
  }

  .export-dropdown {
    padding: 20px 0px;
    width: 258px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
}
.reject-button-modal {
  margin: 10px 0px;
  width: 100%;
  border: none;
  color: #e00000;
  border: 1px solid #e00000;
  border-radius: 5px;
  padding: 0.75rem;
  background: #ffffff;
  cursor: pointer;
}
.accept-button-modal {
  margin: 10px 0px;
  border: 1px solid #e00000;
  background: #e00000;
  color: #ffffff;
  width: 100%;
  padding: 0.75rem;
  border-radius: 5px;
  cursor: pointer;
}
.field-set {
  border: 1px solid #cccccc;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 20px 0;

  .ant-select-selection.ant-select-selection--single {
    border: 1px solid #ffffff;
    margin-top: -5px;
    margin-bottom: 10px;
  }
}
.w-8 {
  flex-basis: 4% !important;
  max-width: 4% !important;
  -ms-flex-preferred-size: 4% !important;
}
.w-11 {
  flex-basis: 11% !important;
  max-width: 11% !important;
  -ms-flex-preferred-size: 11% !important;
}
.fulfillment-checkbox .ant-checkbox-inner {
  border-color: #999 !important;
}
.col-sla {
  padding-left: 9px !important;
  padding-right: 9px !important;
  -ms-flex: 0 0 12%;
  -webkit-box-flex: 0;
  flex: 0 0 12%;
  max-width: 12%;
}
.booking-state {
  background: white !important;
  border: 1px solid #ccc !important;
}
.allocated-state {
  color: #52c41a !important;
}
.unallocated-state {
  color: #1a1a1a !important;
}
.oos-state {
  color: #f5222d !important;
}
</style>
